import { useAccessGuard } from "@neu/libui";
import { useDefinitionGuard } from "@neu/libui";
import type { GuardStepHook } from "@neu/libui";

export const HOMEBASE_GUARDS: readonly GuardStepHook[] = [
	useDefinitionGuard,
	useAccessGuard,
] as const;
